export default "__VITE_ASSET__D0vWd6oG__"